import { SubscriptionPlan } from '@vacationtracker/shared/types/company'
import { SubscriptionPeriod } from '@vacationtracker/shared/types/billing'

/**
 * Plan hierarchy for determining upgrades and downgrades
 */
export const PLAN_HIERARCHY: Record<SubscriptionPlan, number> = {
  'Enterprise': 4,
  'Complete': 3,
  'Core': 2,
  'Freemium': 1,
}

/**
 * Determines if a plan change is an upgrade
 */
export const isUpgrade = (currentPlan: SubscriptionPlan, newPlan: SubscriptionPlan): boolean => {
  return PLAN_HIERARCHY[newPlan] > PLAN_HIERARCHY[currentPlan]
}

/**
 * Determines if a plan change is a downgrade
 */
export const isDowngrade = (currentPlan: SubscriptionPlan, newPlan: SubscriptionPlan): boolean => {
  return PLAN_HIERARCHY[currentPlan] > PLAN_HIERARCHY[newPlan]
}

/**
 * Determines if the plan is the same but period is different
 */
export const isSamePlan = (currentPlan: SubscriptionPlan, newPlan: SubscriptionPlan): boolean => {
  return currentPlan === newPlan
}

/**
 * Determines if switching from annual to monthly period
 */
export const isSwitchingAnnualToMonthly = (
  currentPlan: SubscriptionPlan,
  newPlan: SubscriptionPlan,
  currentPeriod: SubscriptionPeriod,
  newPeriod: SubscriptionPeriod
): boolean => {
  return isSamePlan(currentPlan, newPlan) && currentPeriod === 'annual' && newPeriod === 'monthly'
}

/**
 * Determines if switching from monthly to annual period
 */
export const isSwitchingMonthlyToAnnual = (
  currentPlan: SubscriptionPlan,
  newPlan: SubscriptionPlan,
  currentPeriod: SubscriptionPeriod,
  newPeriod: SubscriptionPeriod
): boolean => {
  return isSamePlan(currentPlan, newPlan) && currentPeriod === 'monthly' && newPeriod === 'annual'
}

